import { useMemo } from 'react';
import { SelectInputField, TextInputField } from './fields';
import { useUserFormMeta } from './userFormMeta';
import { ACCESS_ROLE_OPTIONS, FIELD_LABELS, FIELD_PLACEHOLDERS, PHONE_MAX_DIGITS, REQUIRED_FIELD_NOTE, STEP_HEADINGS } from './constants';
import styles from './UserFormModal.module.scss';

const UserInfoStep = () => {
  const { roleAvailability } = useUserFormMeta();

  // Disables roles the org has no quota left for; a failed/missing fetch leaves all roles selectable.
  const roleOptions = useMemo(
    () =>
      ACCESS_ROLE_OPTIONS.map((option) => {
        const availability = roleAvailability?.[option.value];
        if (!availability || availability.available) return option;
        return { ...option, disabled: true, title: availability.reason ?? undefined };
      }),
    [roleAvailability],
  );

  return (
    <section className={styles.step}>
      <h3 className={styles.stepHeading}>
        {STEP_HEADINGS.USER}
        <span className={styles.requiredNote}>
          <span className={styles.requiredMark}>*</span>
          {REQUIRED_FIELD_NOTE}
        </span>
      </h3>

      <TextInputField name="name" label={FIELD_LABELS.NAME} placeholder={FIELD_PLACEHOLDERS.NAME} required />
      <TextInputField name="title" label={FIELD_LABELS.TITLE} placeholder={FIELD_PLACEHOLDERS.TITLE} />
      <TextInputField name="email" label={FIELD_LABELS.EMAIL} placeholder={FIELD_PLACEHOLDERS.EMAIL} required />
      <SelectInputField name="role" label={FIELD_LABELS.ACCESS} placeholder={FIELD_PLACEHOLDERS.ACCESS} options={roleOptions} required />
      <TextInputField name="phone" label={FIELD_LABELS.PHONE} placeholder={FIELD_PLACEHOLDERS.PHONE} maxLength={PHONE_MAX_DIGITS} digitsOnly />
    </section>
  );
};

export default UserInfoStep;
